module.exports = __webpack_public_path__ + "static/media/multiverse1.d8d671ad.png";